export const doctorConstants = {
  GETALL_DOCTORS_REQUEST: 'GETALL_DOCTORS_REQUEST',
  GETALL_DOCTORS_SUCCESS: 'GETALL_DOCTORS_SUCCESS',

  DOCTOR_SET_LANDING_PAGE: 'DOCTOR_SET_LANDING_PAGE'
}